import type {AddClientContactFormPayload} from "./add-client-contact.schema";

import {addClientContact} from "@project/sdk/sales";
import {AddClientContactBody} from "@project/sdk/sales/zod";
import {mutationOptions} from "@tanstack/react-query";

import {clientKeys, clientMutationKeys} from "../../../../../client-keys";

import {addClientContactMapper} from "./add-client-contact.mapper";

export function addClientContactMutationOptions(clientId: string) {
  return mutationOptions({
    mutationFn: (payload: AddClientContactFormPayload) =>
      addClientContact(clientId, AddClientContactBody.parse(addClientContactMapper.toSdk(payload))),
    mutationKey: clientMutationKeys.addClientContact,
    onSuccess: async (_contactId, _payload, _context, {client}) => {
      await Promise.all([
        client.invalidateQueries({queryKey: clientKeys.detail(clientId)}),
        client.invalidateQueries({queryKey: clientKeys.lists()}),
      ]);
    },
  });
}
